import template from './cargo-lifts.jade';

export default angular
    .module('cian.addForm.cardoLifts', [])
    .directive('cianAfAboutBuildingCargoLifts', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
          'ngInject';

          this.isMobile = deviceService.isMobile;

          this.values = [
              { name: 'нет', key: undefined },
              { name: '1', key: 1 },
              { name: '2', key: 2 },
              { name: '3', key: 3 },
              { name: '4', key: 4 },
          ];
        },
        controllerAs: 'cargoLifts',
        template,
    }))
    .name;
